export class Player {
  targeted_block: [number, number];

  constructor() {
    this.targeted_block = [0, 0];
  }
}
